import { Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import Flex from '@Components/Bases/Flex';
import { ESG_PLAN } from '@Domains/Esg/EsgPlan';

import EsgPlansFooter from './Containers/EsgPlansFooter';
import SelectEsgFormFields from './Containers/SelectEsgFormFields';

export type EsgPlansFormValues = {
  esgPlatform: boolean;
  esgGreenhouse: boolean;
};

const defaultValues: EsgPlansFormValues = {
  esgPlatform: false,
  esgGreenhouse: false,
};

const mapEsgCharacteristic = (characteristicTypes: Array<ESG_PLAN>) => {
  const esgCharacters = { ...defaultValues };

  characteristicTypes.forEach((characteristicType) => {
    if (characteristicType === ESG_PLAN.DATA_PLATFORM) {
      esgCharacters.esgPlatform = true;
    }
    if (characteristicType === ESG_PLAN.GREEN_HOUSE) {
      esgCharacters.esgGreenhouse = true;
    }
  });

  return esgCharacters;
};

const EsgPlans = () => {
  const context = useForm<EsgPlansFormValues>({
    mode: 'onChange',
    defaultValues,
  });

  return (
    <FormProvider {...context}>
      <form noValidate style={{ width: '100%' }}>
        <Flex p={2} flexDirection={'column'} gap={2}>
          <Typography variant="h3">ส่วนที่ 3 แผนการยกระดับ</Typography>
          <SelectEsgFormFields />
        </Flex>
        <EsgPlansFooter />
      </form>
    </FormProvider>
  );
};

export default EsgPlans;
